import authService from '../utils/auth.js';
import { getApiBaseUrl } from '../utils/apiBase.js';

export class NovaErpIntegrationError extends Error {
  constructor(message, { code, status } = {}) {
    super(message);
    this.name = 'NovaErpIntegrationError';
    this.code = code;
    this.status = status;
  }
}

async function request(path, { method = 'GET', body } = {}) {
  const response = await fetch(`${getApiBaseUrl()}/api/integrations/novaerp${path}`, {
    method,
    headers: authService.getAuthHeaders(),
    body: body ? JSON.stringify(body) : undefined
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new NovaErpIntegrationError(
      data.message || `NovaERP request failed (${response.status})`,
      { code: data.code, status: response.status }
    );
  }
  return data;
}

export const getNovaErpStatus = () => request('/status');

export const disconnectNovaErp = () => request('/connection', { method: 'DELETE' });

// One-click sign-in for the NovaERP card (falls back to NovaERP's sign-in page when SSO is off).
export const autoLoginNovaErp = () => request('/auto-login', { method: 'POST' });

// Sends the browser to NovaERP's "Allow NovaBotX" screen; NovaERP returns to My Apps afterwards.
export async function connectNovaErp() {
  const data = await request('/connect', { method: 'POST', body: { returnTo: 'apps' } });
  if (!data?.authorizeUrl) throw new NovaErpIntegrationError('NovaERP did not return a sign-in link');
  window.location.href = data.authorizeUrl;
}
